import { circleTick } from "@simplybusiness/icons";
import type { DOMProps } from "@simplybusiness/mobius";
import {
  Flex,
  Icon,
  List,
  ListItem,
  Segment,
  Text,
  Trust,
} from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { RefAttributes } from "react";

export type TrustSectionElement = HTMLDivElement;

export interface TrustSectionProps
  extends DOMProps, RefAttributes<TrustSectionElement> {
  /** Custom class name for setting specific CSS */
  className?: string;
  elementType?: React.ElementType;
}

export const TrustSection = ({ ref, ...props }: TrustSectionProps) => {
  const { elementType: Element = "div", ...otherProps } = props;

  const classes = classNames(
    "mobius",
    "mobius-trust-section",
    otherProps.className,
  );

  return (
    <Element ref={ref} {...otherProps} className={classes}>
      <Segment className="mobius-trust-section__header">
        <Text elementType="h2">How our licensed agents can help</Text>
      </Segment>
      <Segment className="mobius-trust-section__body">
        <Flex
          flexDirection="column"
          alignItems="center"
          className="mobius-trust-section__body-content"
        >
          <List
            icon={
              <Icon
                icon={circleTick}
                color="var(--color-valid)"
                title="Benefits included"
              />
            }
            className="mobius-trust-section__list"
          >
            <ListItem>
              <Text>Speak to a small business insurance expert</Text>
            </ListItem>
            <ListItem>
              <Text>Ask questions and get answers right away</Text>
            </ListItem>
            <ListItem>
              <Text>Get coverage for your unique business</Text>
            </ListItem>
          </List>
          <Trust locale="en-US" theme="light" variant="mini" />
          <Text>
            <strong>150,000 customers served</strong>
          </Text>
        </Flex>
      </Segment>
    </Element>
  );
};

TrustSection.displayName = "TrustSection";
